/** Firebase continue URL (şifre sıfırlama): www ile apex farklı; yetkili domain ile birebir eşleşmeli */
export function getPublicSiteOrigin(): string {
  const fromEnv = process.env.REACT_APP_PUBLIC_SITE_ORIGIN?.replace(/\/$/, '');
  if (fromEnv) return fromEnv;
  if (typeof window === 'undefined') return '';
  if (process.env.NODE_ENV === 'development') return window.location.origin;
  return 'https://eczaneanaliz.com';
}

const config = {
  API_BASE_URL: process.env.NODE_ENV === 'production' 
    ? window.location.origin 
    : 'http://localhost:5000',
  API_ENDPOINTS: {
    AUTH: '/api/auth',
    CATEGORIES: '/api/categories',
    PRODUCTS: '/api/products',
    BRAND_SCORES: '/api/products/brand-scores',
    OPPORTUNITY_RADAR: '/api/products/opportunity-radar',
    WAREHOUSES: '/api/warehouses',
    STRIPE: '/api/stripe'
  },
  STRIPE: {
    PUBLIC_KEY: 'pk_test_51RtRMsPOjOSzwqG8f51qQJ03jr9HkF8RJAkXAR17iBMvbj4yEWJEOLCXVrs36uWWP36m9P8lkVRlwv8IXfdGflL400sewxFg42',
  },
  // Havale/EFT için IBAN (config'den güncellenebilir)
  PAYMENT_IBAN: 'TR66 0001 0002 5698 3102 9850 01',
};

export default config; 